import { render, staticRenderFns } from "./PresidentMessage.vue?vue&type=template&id=63dd1250&scoped=true&"
import script from "./PresidentMessage.vue?vue&type=script&lang=js&"
export * from "./PresidentMessage.vue?vue&type=script&lang=js&"
import style0 from "./PresidentMessage.vue?vue&type=style&index=0&id=63dd1250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd1250",
  null
  
)

export default component.exports